export default __webpack_public_path__ + "static/media/NEON.9b2f918a.ttf";